module.exports = __webpack_public_path__ + "static/draftInvoice.png";